
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
@Component({})
export default class extends Vue {
  @Prop()
  modelValue: any

  @Prop({
    default() {
      return []
    }
  })
  list: { desc: string, name: string, value: string }[];

  /** 只读展示用（如优惠券类型创建后不可修改），选中项仍然高亮，只是点不动 */
  @Prop({ default: false })
  disabled: boolean;

  changeValue(val) {
    if (this.disabled) return;
    this.$emit("update:modelValue", val);
  }
}


